<template>
  <div class="logo">
    <div v-if="!$store.state.isMobile">
      <div class="bgc">
        <div class="logoTop">{{$store.state.ticketDetail.ticketName}}</div>
        <!-- <div class="logoTop" :style="`transform: scale(${logoScale})`" @click="toIndex"><img src="../../assets/ticket/titleLogo.png"></div> -->
        <div class="topRightIcon"></div>
        <div class="botLeftIcon"></div>
      </div>
      <div class="musemCommon">
          <div class="musemName">在线预约</div>
          <div :class="{
            'status': true,
          }">{{$store.state.ticketDetail.currentState == '闭馆' ? '今日闭馆' : $store.state.ticketDetail.currentState}}</div>
          <div class="timeAndDate">开馆时间：{{$store.state.ticketDetail.timeOpen}}&nbsp;-&nbsp;{{$store.state.ticketDetail.timeClose}}&nbsp;&nbsp;停止入馆时间：{{$store.state.ticketDetail.timeStop}}</div>
      </div>
      <div class="logoContent" :style="$store.state.themeData.pcBg ? '' : ''">
        <div class="newLogContent">
          <slot name="title"></slot>
          <div class="title" v-show="contentType != 2 && contentType != 3 ">{{contentTitle[contentType]}}</div>
          <slot name="resetIndex"></slot>
          <slot name="inputs"></slot>
          <div v-if="contentType == 2 || contentType == 3">
              <slot name="button"></slot>  
          </div>
        </div>
        <div class="newCodeBx">
          <div class="erCode">
              <div id="qrCode02" ref="qrcode" class="marTop">
                <!-- <img src="../../assets/ticket/erCode_new.jpg"> -->
              </div>
              <div>扫码前往移动端</div>
            </div>
        </div>
      </div>
    </div>
    <div v-else class="h5" :style="$store.state.themeData.h5Bg ? '' : ''">
      <div :class="`bgc ${$route.query.museumCode == 218425 ? 'jxhy' : ''}`" :style="$store.state.themeData.h5Bg ? `background: url(${$store.state.themeData.h5Bg}) 0 0/cover no-repeat;` : ''">
        <!-- <div class="phoneIconRight"></div>
        <div class="phoneIconLeft"></div>
        <div class="phoneFont1">在线</div>
        <div class="phoneFont2">预约</div> -->
      </div>
      <div :class="`loginContent contentType${contentType}`">
        <slot name="title"></slot>
        <div class="title" v-show="contentType != 2 && contentType != 3">
          <div class="titleShadow"><span class="titleFont">{{contentTitle[contentType]}}</span></div>
        </div>
        <slot name="resetIndex"></slot>
        <slot name="inputs"></slot>
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      ticketDetail: {
        name: '超星博物馆',
        status: 1,
        startTime: '9:00 - 17:00',
        endTime: '16:30',
        maxNum: 5000,
      },
      statusText: ['停业', '开放', '约满'],
      contentTitle: {
        1: '密码登录',
        2: '重置密码',
        3: '新用户注册',
        4: '快捷登录'
      },
      logoScale: 1,
    };
  },

  props: ['contentType'],

  methods: {
    getticketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data || this.$store.state.ticketDetail.ticketName
      })
    },

    // 首页
    toIndex() {
      this.$router.push(`/ticket/home?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
    },

    setErCode() {
      let text = `${location.origin}${location.pathname}#/ticket/home?museumCode=${this.$route.query.museumCode}`;
      new QRCode(this.$refs.qrcode, {
        text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setErCode()
    })
  },
  created() {
    this.logoScale = window.innerWidth/1400
    window.onresize = () => {
      return (() => {
        this.logoScale = window.innerWidth/1400
      })();
    };
    console.log(123)
    this.$store.state.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    
    if (!this.$store.state.ticketDetail.id) {
      this.getticketDetail()
    }
    this.getMuseum()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.logo{
  .title{
    font-size: 30px;
    line-height: 40px;
    // font-family: STZHONGS;
    text-align: left;
    margin-bottom:27px;
  }
  .musemCommon{
    .musemName{
      font-size: 58px;
      line-height: 77px;
      text-align: center;
      letter-spacing: 0.04em;
      color: #FFE4BC;
      // font-family: STZHONGS;
      margin-top:157px;
      margin-bottom:23.5px;
      font-family: FZDBSJW;
      letter-spacing: 13.6px;
      font-weight: 400;
    }
    .status {
      width:116px;
      height: 28.5px;
      background:url(../../assets/images/status.png) no-repeat;
      background-size: 100%;
      text-align: center;
      font-size: 18px;
      line-height: 28.5px;
      color:#fff;
      margin:0 auto;
      // font-family:STZHONGS;
    }
    .timeAndDate{
      width:430px;
      height:38px;
      margin:16px auto 20px auto;
      background:rgba(255,228,188,.1);
      border-radius: 2px;
      // font-family:STZHONGS;
      color:#fff;
      font-size:14px;
      line-height:38px;
    }
  }
  
  .bgc{
    height: 607px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    .logoTop{
      position:absolute;
      top:27px;
      left:77px;
      cursor: pointer;
      color: #FFE4BC;
      font-size: 23px;
      font-family: FZDBSJW;
      img{
        width:100%;
        height:100%;
      }
    }
    .topRightIcon{
      width:45px;
      height:134px;
      background:url(../../assets/images/bannerIcon.png) no-repeat;
      transform: rotate(180deg);
      position:absolute;
      top:50px;
      right:80px;
    }
    .botLeftIcon{
      width:45px;
      height:134px;
      background:url(../../assets/images/bannerIcon.png) no-repeat;
      position:absolute;
      bottom:50px;
      left:80px;
    }
    &:before{
      position: absolute;
      width: 100%;
      height: 360px;
      content: '';
      display: inline-block;
      background-color: #ffffff33;
      -webkit-mask: url('~@/assets/images/pcTopBg.svg') 0 0/cover no-repeat;
      mask: url('~@/assets/images/pcTopBg.svg') 0 0/cover no-repeat;
      left: 0;
      bottom: 0;
    }
  }
  .bgc1,.bgc2{
    background:url(../../assets/images/pcPasswordBg.jpg) no-repeat center;
    background-size: cover;
  }
  .bgc3{
    background:url(../../assets/images/pcRegisterBg.jpg) no-repeat center;
    background-size: cover;
  }
  .logoContent{
    width: 918px;
    position: relative;
    background-color: #fff;
    margin:0 auto;
    box-shadow: 0px 0px 36px 20px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding:9px;
    display: flex;
    justify-content: space-between;
    margin-bottom:53px;
    box-sizing: border-box;
    &::after{
      content:'';
      position:absolute;
      width:100%;height:50px;
      background: url(../../assets/images/loginBg.png) no-repeat;
      background-size:100%;
      left:0;
      bottom:-51px
    } 
    .name{
      font-size: 0.25rem;
      font-weight: 500;
      color: #333;
    }
    
    .newCodeBx{
      width:45%;
      background: linear-gradient(180deg, #F7F7FA 0%, #F9FDFF 100%);
      border-radius: 10px;
      align-self: stretch;
      -webkit-align-self: stretch;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      .erCode{
        font-size: 16px;
        div{
          margin-top: 20px;
        }
      }
      .marTop{
        margin-top:24px
      }
    }
    .newLogContent{
      width:55%;
      padding: 3% 6%;
      box-sizing: border-box;
    }
    .openStatus{

    }
    .status{
      width: 110px;
      border-radius: 40px;
      font-size: 16px;
      line-height: 32px;
      color: #fff;
      margin: 15px auto;
      background: #e09a19;
    }
    .status_g{
      background-color: #7fa704;
    }
    .status_r{
      background-color: red;
    }
    .status_y{
      background-color: yellow;
    }
    .timeAndDate{
      font-size: 0.1rem;
      margin: 0.2rem 0;
    }
    .inputPhone, .inputCode{
      width: 100%;
      margin:auto;
      position: relative;
    }
    .inputPhone::before{
      display: inline-block;
      content: '';
      height: 0.2rem;
      width: 0.1rem;
      // background: url('~@/assets/ticket/icon_phone.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.2rem;
      left: 0.4rem;
      z-index: 222;
    }
    .inputCode::before{
      display: inline-block;
      content: '';
      height: 0.2rem;
      width: 0.1rem;
      // background: url('~@/assets/ticket/icon_password.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.2rem;
      left: 0.4rem;
      z-index: 222;
    }
    .button1{
      position: absolute;
      top: 0.17rem;
      right: 0.4rem;
      font-size:14px
    }
    .bottomWarp{
      position: relative;
    }
    .button{
      margin-top: 0.5rem;
      margin-left: 1.7rem;
      min-height: 0.5rem;
    }
  }
  .h5{
    // min-height: 100vh;
    // font-family: STZHONGS;
    padding-bottom: 2rem;
    .title{
      font-size: 0.6rem;
      line-height: 1;
      margin-bottom:1rem;
      text-align: left;
      .titleShadow{
        position: relative;
        display: inline-block;
        padding:0 .16rem;
        &::before{
          content: '';
          position: absolute;
          width:100%;
          height:.16rem;
          border-radius:1.56rem;
          left:0;
          bottom:0
        }
      }
      .titleFont{
        position:relative;
        z-indx:10
      }
    }
     .bgc{
      // background:none;
      height:7rem;
      &.jxhy{
        background: url('~@/assets/ticket/jxhy_bg.png') 0 0/cover no-repeat;
        margin-top: -1rem;
      }
      &:before{
        width: 5.6rem;
        height: 4.9rem;
        position: absolute;
        content: '';
        display: inline-block;
        // background:url(../../assets/ticket/yun1.png) 0 0/contain no-repeat;
        bottom: 0rem;
        left: -1rem;
      }
      &:after{
        width: 5.6rem;
        height: 4.3rem;
        position: absolute;
        content: '';
        display: inline-block;
        // background:url(../../assets/ticket/yun2.png) 0 0/contain no-repeat;
        right: 0;
        bottom: 0rem;
      }
      .phoneLogo{
        position: absolute;
        width:4rem;
        height:.86rem;
        background:url(../../assets/ticket/titleLogo.png) no-repeat;
        background-size: 100%;
        top:.44rem;
        left:.7rem
      }
      .phoneIconRight{
        position: absolute;
        width:.36rem;
        height:1.1rem;
        background:url(../../assets/images/bannerIcon.png) no-repeat;
        background-size: 100%;
        top:.8rem;
        right:.8rem;
        transform:rotate(180deg)
      }
      .phoneIconLeft{
        position: absolute;
        width:.36rem;
        height:1.1rem;
        background:url(../../assets/images/bannerIcon.png) no-repeat;
        background-size: 100%;
        top:4.4rem;
        left:.8rem;
      }
      .phoneFont1,.phoneFont2{
        position: absolute;
        color: #FFE4BC;
        top:1.5rem;
        right:4.2rem;
        font-size: 0.4rem;
        writing-mode: lr-tb;
        width: 0.45rem;
      }
      .phoneFont1:after{
        width: 0.3rem;
        height: 0.52rem;
        background: url(../../assets/ticket/home_icon1.png) 0 0/100% no-repeat;
        content:'';
        display: inline-block;
      }
      .phoneFont2:after{
        width: 1.1rem;
        height: 0.29rem;
        background: url(../../assets/ticket/home_icon2.png) 0 0/100% no-repeat;
        content:'';
        display: inline-block;
        transform: translateX(-2.3rem);
      }
      .phoneFont2{
        right: 4.8rem;
        top: 2.2rem;
      }
    }
    .bgc1{
      background:url(../../assets/images/bgc1.png) no-repeat;
      background-size: 100%;
    }
    .bgc2{
      background:url(../../assets/images/bgc2.png) no-repeat;
      background-size: 100%;
    }
    .bgc3{
      background:url(../../assets/images/bgc3.png) no-repeat;
      background-size: 100%;
    }
    .bgc4{
      background:url(../../assets/images/bgc4.png) no-repeat;
      background-size: 100%;
    }
    .loginContent{
      // position: fixed;
      // top:5rem;
      width:9rem;
      padding: .65rem .8rem;
      background: #FFFFFF;
      box-shadow: 0px .05rem .26rem rgba(183, 183, 182, 0.18);
      border-radius: 0.2rem;
      min-height:11.7rem;
      box-sizing:border-box;
      // left:50%;
      // margin-left:-4.5rem
      margin: auto;
      margin-top: 5rem;
    }
  }
}
</style>
<style type="text/css">
  .logoContent .el-input__inner{
    width: 3rem;
    margin: 0.1rem;
    padding: 0.05rem 0.4rem;
    padding-right: 1rem;
    background-color: #f6f6f6;
    height: 0.35rem;
    border: unset;
  }
  .h5 .inputCode .el-input{
    display: block;
  }
  .inputCode .el-input__inner{
    
    /*width: 2rem;*/
    /*padding-right: ;*/
  }
  .loginContent .el-input__inner{
    margin: 0.3rem 0;
    height: 1.2rem;
    width: 8rem;
    border-radius: 0.6rem;
    font-size: 0.4rem;
    line-height: 1.2rem;
  }

  .logoContent .bottomWarp #qrCode img{
    width: 100%;
    height: 100%;
  }
  
  .h5 .loginContent .el-input__inner{
    border:0 !important;
    border-bottom:solid 1px #E9E9E9 !important;
    border-radius: 0;
    width:100%;
    padding:0;
    margin:0;
    font-size:.4rem;
    /*font-family: STZHONGS;*/
    font-weight: normal;
    line-height:1.35rem
  }
  .h5 .loginContent .el-input__inner:focus{
    border-color:#333 !important;
  }
  .h5 .inputPhone .el-input__suffix{
    width:.4rem;
    background-size:.4rem .4rem
  }
  .logo .erCode img{
    width: 210px;
    height: 210px;
    margin: auto;
  }
</style>
